import { useSingleWorkflowQuery } from '../api';
  import { SingleEntityPage } from '../components/organisms/SingleEntityPage';
  import { DateTime } from 'luxon';
  import { formatCurrency } from '../system/util';
  import { ExternalUrl, Field, useSingleEntity, Email, EntityLink, EntityFieldDisplayName, BodyText } from '../components';
  import { Workflow } from '../api';
  
  export const WorkflowPage = ({ RecordID }: { RecordID: number }) => {
    return (
      <SingleEntityPage
        RecordID={RecordID}
        EntityName="Workflows"
        queryHook={useSingleWorkflowQuery}
        Details={<WorkflowDetails />}
      />
    );
  };

  export const WorkflowDetails = () => {
    const [workflow] = useSingleEntity<Workflow>();
    return (
      <div>
        <Field label={<EntityFieldDisplayName Entity="Workflows" EntityField="ID" />} value={workflow?.ID} />
        <Field label={<EntityFieldDisplayName Entity="Workflows" EntityField="Name" />} value={workflow?.Name} />
        <Field label={<EntityFieldDisplayName Entity="Workflows" EntityField="Description" />} value={<BodyText>{workflow?.Description}</BodyText>} />
        <Field label={<EntityFieldDisplayName Entity="Workflows" EntityField="WorkflowEngineID" />} value={<EntityLink Entity="Workflows" EntityField="WorkflowEngineID">{workflow?.WorkflowEngineID}</EntityLink>} />
        <Field label={<EntityFieldDisplayName Entity="Workflows" EntityField="CompanyID" />} value={workflow?.CompanyID} />
        <Field label={<EntityFieldDisplayName Entity="Workflows" EntityField="ExternalSystemRecordID" />} value={workflow?.ExternalSystemRecordID} />
        <Field label={<EntityFieldDisplayName Entity="Workflows" EntityField="CreatedAt" />} value={workflow?.CreatedAt &&
            DateTime.fromMillis(workflow.CreatedAt).toLocaleString(DateTime.DATETIME_SHORT)} />
        <Field label={<EntityFieldDisplayName Entity="Workflows" EntityField="UpdatedAt" />} value={workflow?.UpdatedAt &&
            DateTime.fromMillis(workflow.UpdatedAt).toLocaleString(DateTime.DATETIME_SHORT)} />
        <Field label={<EntityFieldDisplayName Entity="Workflows" EntityField="WorkflowEngine" />} value={workflow?.WorkflowEngine} />
      </div>
    );
  };
